import { Button, makeStyles, useMediaQuery } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CollapseCounsil from "./Components/CollapseCounsil";
import { post } from "../../utils/jobsAxiosInstance";
import AutoComplete from "./Components/AutoComplete";
import GroupedAutoComplete from "./Components/GroupedAutoComplete";
import { useCommonJobStyles } from ".";

const useStyles = makeStyles((theme) => ({
    root: {
        [theme.breakpoints.down("xs")]: {
            margin: '2rem auto 0 auto',
            padding: '4rem 2rem 1rem 2rem !important',
        },
        margin: '5rem auto 0 auto',
        padding: '4rem 6rem !important',
    },
    filterSections: {
        [theme.breakpoints.down("sm")]: {
            marginTop: '1rem'
        },
        marginTop: '4rem'
    },
    mainFilterBoxContainer: {
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
            gap: "1rem"
        },
        display: 'flex',
        gap: "2rem",
        '& div:nth-child(-n+2)': {
            flexBasis: "40%"
        },
        '& button': {
            textTransform: 'none',
            background: '#315CD5 !important',
            padding: '1rem',
            borderRadius: '8px',
            color: '#FFF',
            height: "3.5rem",
            width: '100%',
            flexBasis: "20%"
        }
    },
    mainFilterInputs: {
        display: 'flex',
        gap: "1rem",
        background: "#ffffff",
        alignItems: "center",
        borderRadius: "0.5rem",
        padding: '0 0.5rem 0 1rem',
        '& input': {
            width: "100%",
            border: 'none',
            outline: "none",
            height: "3.5rem",
        },
    },
    subFilterBoxContainer: {
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
        },
        display: "flex",
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        gap: "1rem",
        '& svg': {
            width: '20px !important',
            height: '20px !important',
        },
        '& input, select': {
            height: "3.5rem",
        },
    },
    autocomplete: {
        minWidth: '11rem',
        flexGrow: "1",
        "& > * + *": {
            marginTop: theme.spacing(3),
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                border: 'none',
            },
            '&:hover fieldset': {
                border: 'none',
            },
            '&.Mui-focused fieldset': {
                border: 'none',
            },
        },
        '& .MuiInputBase-root, & .MuiSelect-root': {
            border: 'none',
            outline: 'none',
            color: '#7283B3',
            borderRadius: '0.5rem',
            background: '#fff'
        },
        '& .MuiInputBase-root': {
            padding: '0.3rem 1rem 0 0.5rem',
            '& input': {
                padding: '0  !important',
                paddingLeft: '6px  !important'
            }
        },
        '& .MuiInputBase-root::placeholder': {
            color: '#7283B3',
        },
    },
    iconDimentions: {
        width: '25px !important',
        height: '100% !important',
        fontSize: '1rem',
    },
    iconColor: {
        color: '#315CD5'
    }
}))

const FilterJobs = (props) => {

    const classes = useStyles();
    const commonClasses = useCommonJobStyles();
    const isSMScreen = useMediaQuery((theme) => theme.breakpoints.down('xs'));
    const { userFilters, setUserFilters, searchFilters, setSearchFilters } = props;
    const [filters, setFilters] = useState();

    useEffect(() => {
        post('filter/values')
            .then((res) => {
                const filterData = convertDataToFilter(res.data.filterValues);
                setFilters(filterData);
                props.setRawFilters(res.data.filterValues);
            })
            .catch(() => {
                setFilters(null);
                props.setRawFilters(null);
            })
    }, [])

    const splitDateObj = (mindate, maxDate) => {
        const minDateObj = new Date(mindate);
        const maxDateObj = new Date(maxDate);
        const spans = [];
        let currentStart = new Date(minDateObj);

        while (currentStart < maxDateObj) {
            let currentEnd = new Date(currentStart);
            currentEnd.setMonth(currentEnd.getMonth() + 3);
            if (currentEnd > maxDateObj) {
                currentEnd = new Date(maxDateObj);
            }
            spans.push(
                currentStart.toDateString().split(' ').slice(1).join(' ') + "  to  " +
                currentEnd.toDateString().split(' ').slice(1).join(' ')
            );
            currentStart = new Date(currentEnd);
            currentStart.setDate(currentStart.getDate() + 1);
        }

        return spans.reverse();
    }

    const getLocationList = (locationObject) => {
        const countries = Object.keys(locationObject)?.sort();
        let locations = [];
        for (const country of countries) {
            locations.push({ groupKey: country, child: `All states of ${country}`, isSelectAllChildOption: true })
            for (const state of locationObject[country]) {
                locations.push({ groupKey: country, child: state })
            }
        }
        return locations;
    };

    function splitNumberRange(min, max) {
        const ranges = [];
        let start = min;

        while (start < max) {
            const end = Math.min(start + 100000, max);
            ranges.push(start.toLocaleString() + "  to  " + end.toLocaleString());
            start = end + 1;
        }

        return ranges;
    }

    const convertDataToFilter = (data) => {
        const filterData = [];
        for (let key in data) {
            const filter = {
                element: 'select',
                name: key,
                options: data[key],
                defaultValue: "",
                placeholder: key,
            }
            if (key.toLowerCase().includes('locations')) {
                filter['element'] = 'groupedSelect';
                filter['defaultValue'] = [];
                filter['placeholder'] = "Select location";
                filter['options'] = getLocationList(filter['options']);
            }
            if (key.toLowerCase().includes("postingdate")) {
                filter['placeholder'] = "Select posting date";
                filter['options'] = Object.values(filter['options']).sort();
            }
            if (key.toLowerCase().includes('compensation')) {
                filter['placeholder'] = "Select compensation range";
                filter['options'] = splitNumberRange(filter['options'].min, filter['options'].max);
            }
            if (key.toLowerCase().includes('companies')) {
                filter['placeholder'] = "Select companies";
            }
            if (filter['options']?.length != 0) {
                filterData.push(filter);
            }
        }
        return filterData;
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        props.getJobs()
    }

    const handleChange = (key, val) => {
        setUserFilters(prev => ({ ...prev, [key]: val }));
    }

    const handleSearchChange = (key, val) => {
        setSearchFilters(prev => ({ ...prev, [key]: val }));
    }

    const extraFilters = (filters &&
        <div className={`${classes.subFilterBoxContainer}`}>
            {filters.map((filter, idx) => {
                if (filter.element === 'input') {
                    return <input
                        key={idx + filter.element}
                        placeholder={filter.placeholder}
                        type={filter.type}
                        value={userFilters[filter.name] ? userFilters[filter.name] : ''}
                        name={filter.name}
                        onChange={(e) => handleChange(filter.name, e.target.value)}
                    />
                }
                if (filter.element === 'select') {
                    return (
                        <AutoComplete
                            key={idx + filter.element}
                            componentName={filter.name}
                            limitTags={2}
                            value={userFilters[filter.name] ? userFilters[filter.name] : []}
                            onChange={(value) => handleChange(filter.name, value)}
                            options={filter.options}
                            classes={classes}
                            placeholder={filter.placeholder}
                        />
                    )
                }
                if (filter.element === 'groupedSelect') {
                    return (
                        <GroupedAutoComplete
                            key={idx + filter.element}
                            componentName={filter.name}
                            limitTags={2}
                            value={userFilters[filter.name] ? userFilters[filter.name] : []}
                            onChange={(value) => handleChange(filter.name, value)}
                            options={filter.options}
                            classes={classes}
                            placeholder={filter.placeholder}
                        />
                    )
                }
            })}
        </div>
    )

    return (
        <section className={classes.root}>
            <h1 className={commonClasses.textCenter}>Get your job in minutes</h1>
            <form onSubmit={handleSubmit}>
                <div className={`${classes.mainFilterBoxContainer} ${classes.filterSections}`}>
                    <div className={classes.mainFilterInputs}>
                        <h4>What</h4>
                        <input
                            placeholder="Job title, keywords, or company"
                            name="searchQuery"
                            value={searchFilters['searchQuery'] ? searchFilters['searchQuery'] : ''}
                            onChange={(e) => handleSearchChange('searchQuery', e.target.value)}
                        />
                    </div>
                    <div className={classes.mainFilterInputs}>
                        <h4>Where</h4>
                        <input
                            placeholder="Washington, United States"
                            name="locationQuery"
                            value={searchFilters['locationQuery'] ? searchFilters['locationQuery'] : ''}
                            onChange={(e) => handleSearchChange('locationQuery', e.target.value)}
                        />
                    </div>
                    <Button type="submit">Search Job</Button>
                </div>

                {extraFilters && <div className={classes.filterSections}>
                    {isSMScreen && <CollapseCounsil title={"Filters"} >
                        {extraFilters}
                    </CollapseCounsil>}
                    {!isSMScreen && extraFilters}
                </div>}
            </form>
        </section >
    )
}

export default FilterJobs;